import * as Yup from 'yup'
import {
  apartmentSchema,
  citySchema,
  houseLetterSchema,
  houseNumberSchema,
  mainOfficeCitySchema,
  mainOfficeNumberSchema,
  officeSchema,
  premisesTypeSchema,
  reserveOfficeCitySchema,
  reserveOfficeNumberSchema,
  streetSchema,
} from '../../../../../../_metronic/helpers/custom/yup/partials/addressesPartials'
import {
  basicNameSchema,
  patronymicOptionalSchema,
  phoneNumberSchema,
} from '../../../../../../_metronic/helpers/custom/yup/partials/generalPartials'
import {passportSchema, receiverTypeSchema, recTypeOfDeliverySchema} from './partials'
import {emailRegex} from '../../../../../../_metronic/helpers/custom/regexs'

const receiverOverviewSchema = (intl: any, regex: string|undefined) =>
  Yup.object().shape({
    active: Yup.number().required(intl.messages.YUP_VALIDATION_RECEIVER_PICK_STATUS),
    firstName: basicNameSchema(intl, intl.messages.YUP_VALIDATION_GENERAL_ENTER_NAME, regex),
    lastName: basicNameSchema(intl, intl.messages.YUP_VALIDATION_GENERAL_ENTER_LAST_NAME, regex),
    patronymic: patronymicOptionalSchema(intl, regex),
    passport: passportSchema,
    receiverType: receiverTypeSchema(intl),
  })

const receiverContactsSchema = (intl: any) =>
  Yup.object().shape({
    phoneNumber: Yup.string().test(
      'is-valid-phone',
      intl.formatMessage({id: 'GENERAL.ERRORS.WRONG_PHONE_NUMBER'}),
      function (value) {
        return this.parent.phoneNumber_valid === true
      }
    ),
    phoneNumber_valid: Yup.boolean(),
    email: Yup.string()
      .required(intl.formatMessage({id: 'VALIDATION.REQUIRED'}))
      .email(intl.formatMessage({id: 'VALIDATION.EMAIL'}))
      .min(5)
      .max(50)
      .matches(emailRegex),
  })

const addReceiverSchema = (intl: any, regex: string | undefined) => [
  Yup.object().shape({
    firstName: basicNameSchema(intl, intl.messages.YUP_VALIDATION_GENERAL_ENTER_NAME, regex),
    lastName: basicNameSchema(intl, intl.messages.YUP_VALIDATION_GENERAL_ENTER_LAST_NAME, regex),
    patronymic: patronymicOptionalSchema(intl, regex),
    passport: passportSchema,
    receiverType: receiverTypeSchema(intl),
  }),
  Yup.object().shape({
    phoneNumber: Yup.string().test(
      'is-valid-phone',
      intl.formatMessage({id: 'GENERAL.ERRORS.WRONG_PHONE_NUMBER'}),
      function (value) {
        return this.parent.phoneNumber_valid === true
      }
    ),
    phoneNumber_valid: Yup.boolean(),
    email: Yup.string()
      .required(intl.formatMessage({id: 'VALIDATION.REQUIRED'}))
      .email(intl.formatMessage({id: 'VALIDATION.EMAIL'}))
      .min(5)
      .max(50)
      .matches(emailRegex),
    typeOfDelivery: recTypeOfDeliverySchema(intl),
    houseNumber: houseNumberSchema(intl),
    houseLetter: houseLetterSchema(intl),
    street: streetSchema(intl),
    premisesType: premisesTypeSchema(intl),
    apartment: apartmentSchema(intl),
    office: officeSchema(intl),
    city: citySchema(intl),
    mainOfficeCity: mainOfficeCitySchema(intl),
    mainOfficeNumber: mainOfficeNumberSchema(intl),
    reserveOfficeCity: reserveOfficeCitySchema(intl),
    reserveOfficeNumber: reserveOfficeNumberSchema(intl),
  }),
]

export {receiverOverviewSchema, receiverContactsSchema, addReceiverSchema}
